const home = () => {

    $(document).ready(function () {

        let $loader = $('.js-ajax-loader');

        setTimeout(function() {
            $loader.removeClass('active');
        }, 500)
    })

};


home();